import { useInfiniteSelect } from "src/system/useInfiniteSelect.ts";
import {
  ProductGroupFilters,
  ProductGroupIncludes,
  type ProductGroupResource,
} from "@exonn/js-sdk";
import { ResourceEnum } from "src/constants/constants.ts";
import { keepPreviousData } from "@tanstack/react-query";
const MAX_PRODUCT_GROUPS_PAGE_SIZE = 200;

const truncatePath = (path: string[]) => {
  if (path.length < 4) {
    return path;
  }

  return [path[0], "...", ...path.slice(-2)];
};

export const useProductGroups = ({
  search,
  resource,
}: {
  search: string;
  resource: string;
}) => {
  return useInfiniteSelect<ProductGroupResource>({
    resource: ResourceEnum.ProductGroup,
    search,
    pageSize: MAX_PRODUCT_GROUPS_PAGE_SIZE,
    searchField: ProductGroupFilters.DeepTitle,
    include: [ProductGroupIncludes.Ancestors],
    queryOptions: {
      enabled: resource === ResourceEnum.Variant,
      refetchOnMount: true,
      placeholderData: keepPreviousData,
      staleTime: 0, // Data is considered stale immediately
      gcTime: 0,
    },
    labelProp: (group) => {
      return truncatePath(group.path.map((group) => group.title)).join(" / ");
    },
  });
};
